import styles from './TooltipIconButton.module.css';
import { Tooltip } from '@mui/material';

function TooltipIconButton({ clickHandler, classes, iconImage, title, imgProps }) {
    return (
        <Tooltip title={title}>
            <img
                onClick={() => clickHandler(true)}
                className={`${styles['tc-cs-footer--camera-icon']} ${classes}`}
                alt="report"
                src={iconImage}
                {...imgProps}
            />
        </Tooltip>
    );
}

export default TooltipIconButton;
